import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDryCleaninginline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M32 11a3 3 0 1 0-3-3m3 3v3",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M27 14h10" }),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "square",
				d: "M38.364 12.757L32 19.121l3.121 3.122 6.364-6.364z"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M41 16c6.333 0 9.167 2.667 9.5 8 .333 5.333.833 14.667 1.5 28h-8",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "square",
				d: "M44 29v30H32m-6.364-46.243L32 19.121l-3.121 3.122-6.364-6.364z"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23 16c-6.333 0-9.167 2.667-9.5 8-.333 5.333-.833 14.667-1.5 28h8",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "square",
				d: "M20 29v30h12m0-39v39"
			})
		]
	})
});
export default SvgDryCleaninginline;
